import React from "react";
import { CommonIconProps } from "./types";
import { IconBase } from "./IconBase"; // Import IconBase

export const IconPng: React.FC<CommonIconProps> = (props) => {
  return (
    <IconBase
      iconStyle="solid"
      {...props}
      pathData={
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.7745 13.2847C12.0867 13.1863 12.4267 13.3017 12.6144 13.5699L14.75 16.6207V14C14.75 13.5858 15.0858 13.25 15.5 13.25C15.9142 13.25 16.25 13.5858 16.25 14V19C16.25 19.3273 16.0377 19.6169 15.7255 19.7153C15.4133 19.8137 15.0733 19.6983 14.8856 19.4301L12.75 16.3793V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V14C11.25 13.6726 11.4623 13.3831 11.7745 13.2847ZM6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H8.5C9.74264 13.25 10.75 14.2574 10.75 15.5C10.75 16.7426 9.74264 17.75 8.5 17.75H7.75V19C7.75 19.4142 7.41421 19.75 7 19.75C6.58579 19.75 6.25 19.4142 6.25 19V14ZM7.75 16.25H8.5C8.91421 16.25 9.25 15.9142 9.25 15.5C9.25 15.0858 8.91421 14.75 8.5 14.75H7.75V16.25ZM17.25 14C17.25 13.5858 17.5858 13.25 18 13.25H21C21.4142 13.25 21.75 13.5858 21.75 14V15C21.75 15.4142 21.4142 15.75 21 15.75C20.5858 15.75 20.25 15.4142 20.25 15V14.75H18.75V18.25H20.25V17.75H20C19.5858 17.75 19.25 17.4142 19.25 17C19.25 16.5858 19.5858 16.25 20 16.25H21C21.4142 16.25 21.75 16.5858 21.75 17V19C21.75 19.4142 21.4142 19.75 21 19.75H18C17.5858 19.75 17.25 19.4142 17.25 19V14Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.27427 19.823C2.27678 21.4403 3.58211 22.75 5.19144 22.75H16.8328C18.0256 22.75 19.0512 22.0306 19.5033 21H7C5.89543 21 5 20.1046 5 19V14C5 12.8954 5.89543 12 7 12H19.75V9.05498C19.75 8.79546 19.6473 8.5466 19.4645 8.36329L12.6564 1.53551C12.4741 1.35268 12.2271 1.25 11.9695 1.25H5.16717C3.55429 1.25 2.24749 2.56532 2.25 4.18619L2.27427 19.823ZM11.5673 3.20594L17.8043 9.46094H13.0673C12.2389 9.46094 11.5673 8.78936 11.5673 7.96094V3.20594Z"
            fill="currentColor"
          />
        </>
      }
    />
  );
};
